import { Component,
         AfterViewInit }        from '@angular/core';
import { MatDialogRef }          from '@angular/material';
import { TrainCycleService }       from './../shared/train-cycle.service';
import { Globals }              from './../common/globals';
import { Observable }           from 'rxjs/Observable';
import { TrainCycleProductDialogModel }     from './train-cycle-product-dialog.model';
import { TrainCycleDialogModel } from '../train-cycle-dialog/train-cycle-dialog.model';
import { TrainCycleProductService } from '../shared/train-cycle-product.service';
import { isNumber } from 'util';

@Component({
  selector: 'sa-train-cycle-product-dialog',
  template: require('./train-cycle-product-dialog.component.html'),
  styles: [require('./train-cycle-product-dialog.component.scss')]
})
export class TrainCycleProductDialogComponent implements AfterViewInit {

  public parentModel: TrainCycleDialogModel;
  public model: Array<TrainCycleProductDialogModel>;
  private productCycles: Observable<any>;
  public requestDeleteCheck = false;
  public loadingProducts = true;

  public errors = [];

  constructor(
    public dialogRef: MatDialogRef<TrainCycleProductDialogComponent>,
    private trainCyclesService: TrainCycleProductService,
    public globals: Globals
  ) {

  }

  ngAfterViewInit() {
    this.trainCyclesService.getItems(this.parentModel.cycleUID).subscribe(p => {
      this.loadingProducts = false;
      this.model = p;
    });
  }

  save() {
    this.errors = [];
    if (this.errors.length === 0) {
      // let modelToUpdate = this.model.filter(m => isNumber(m.orderCoeficient));
      this.trainCyclesService.updateItem(this.parentModel.cycleUID, this.model).subscribe(p => {
        this.dialogRef.close('');
      });
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/train-cycle-product-dialog/train-cycle-product-dialog.component.ts